<template>
  <div>
    <card>
      <div slot="header" class='text-center' style=''>
          銷售方案
      </div>
      <div class="row">
        <div class="col-sm-12">
          <el-table :data="tableData" :show-header="false">
            <el-table-column prop="name" style='text-align:left;' />
            <el-table-column min-width="30px" label="">
              <div class="td-actions" slot-scope="props">
                <a v-tooltip.top-center="'編輯'" class="btn btn-default btn-link btn-xs" @click="handleEdit(props.row)" v-show='props.row.orderDetails.length == 0'>
                  <i class="fa fa-edit" />
                </a>
                <a v-tooltip.top-center="'刪除'" class="btn btn-danger btn-link btn-xs" @click="handleDelete(props.row.id)" v-show='props.row.orderDetails.length == 0 && props.row.salePages.length==0'>
                  <i class="fa fa-close" />
                </a>
              </div>
            </el-table-column>
          </el-table>

          <div class="col-12">
            <el-dialog center :title="getTitle()" :visible.sync="modals.custom">

              <fg-input label="方案名稱"
                type="text"
                name="planName"
                data-vv-as="方案名稱"
                labelClasses="ml-1 mr-3 my-auto"
                inputClasses="col-md-10 col-12"
                v-model="form.planName"
                v-validate="'required'"  
                :error="getError('planName')"
                class='row mx-1'
                required />

              <div class="row mx-1">
                <l-checkbox
                  class='col-2 my-auto'
                  v-model='form.isAdditional'
                  :change="isAdditionalChanged()">
                  加購品
                </l-checkbox>
                <div class='col-10 row'>
                  <label class="mx-1 my-auto">相依方案</label>
                  <el-select
                    class="select-default col-10"
                    multiple
                    data-vv-as="相依方案"
                    placeholder="請選擇"
                    name="dependPlans"
                    v-model="form.dependPlans"
                    :error="getError('dependPlans')"
                    v-bind:disabled=!form.isAdditional
                    v-validate="form.isAdditional ? 'required' : ''" >
                    <el-option v-for="i in planLists" class="select-default" :value="i.id" :label="i.name" :key="'A'+ i.id" />
                  </el-select>
                </div>
              </div>
              
              <l-checkbox class='mx-1' v-model='form.freeShipping'>免運費</l-checkbox>

              <!-- primary items -->
              <card class='col-md-12'>
                <div slot="header">主要商品</div>

                <fg-input
                  label="商品名稱"
                  class='row mx-3'
                  type="text"
                  name="primaryItemName"
                  data-vv-as="主要商品名稱"
                  labelClasses="ml-1 mr-3 my-auto"
                  inputClasses="col-md-9 col-12"
                  v-model="form.primaryItemName"
                  v-validate="'required'"
                  :error="getError('primaryItemName')"
                  required />

                <div class='col-12 row'>
                  <fg-input class="col-3" :error="getError('primarySaleType')">
                    <el-select
                      class="select-default"
                      data-vv-as="主要商品選項"
                      placeholder="請選擇"
                      name="primarySaleType"
                      v-model="form.primarySaleType"
                      :error="getError('primarySaleType')"
                      v-validate="'required'"
                      :change="primarySaleTypeChanged()"
                      clearable="" >
                      <el-option v-for="i in primarySaleTypeOptions" class="select-default" :value="i.id" :label="i.text" :key="'B'+ i.id" />
                    </el-select>
                  </fg-input>

                  <fg-input
                    label="任選入數"
                    class="col-4"
                    :error="getError('primaryCount')">
                    <el-select
                      class="select-default col-md-7 col-12"
                      data-vv-as="任選入數"
                      placeholder="請選擇"
                      name="primaryCount"
                      v-model="form.primaryCount"
                      v-bind:disabled="form.primarySaleType !== 1"
                      :error="getError('primaryCount')"
                      v-validate="form.primarySaleType === 1 ? 'required' : ''" >
                      <el-option v-for="i in itemCount" class="select-default" :value="i.id" :label="i.name" :key="'C'+ i.id" />
                    </el-select>
                  </fg-input>

                  <fg-input
                    label="任選金額"
                    class="col-5 row"
                    type="number"
                    name="primaryTotalPrice"
                    labelClasses="ml-1 mr-3 my-auto"
                    inputClasses="col-md-6 col-12"
                    data-vv-as="任選金額"
                    v-model="form.primaryTotalPrice"
                    v-bind:disabled="form.primarySaleType !== 1"
                    :error="getError('primaryTotalPrice')"
                    v-validate="form.primarySaleType === 1 ? 'required|decimal:2' : ''" />
                </div>
                

                <div class='col-12'>
                  <div class='goodList row' v-bind:key='"D" + index' v-for="(item, index) in form.primaryGoods">                   
                    <div class='col-3'>
                      <input
                        type="text"
                        placeholder="貨號"
                        name="goodsNumber"
                        class="form-control d-inline"
                        style="height: 24px; border-radius: 3px;"
                        data-vv-as='貨號'
                        v-model="item.goodsNumber"
                        v-validate="'required'"
                        ref="savePlanInput" />
                    </div>
                    <div class='ml-2'>
                      <label>金額</label>
                      <input
                        type="number"
                        placeholder="金額"
                        name="goodsPrice"
                        class="form-control input-new-tag"
                        data-vv-as='金額'
                        v-model="item.price"
                        v-bind:disabled="form.primarySaleType !== 0"
                        v-validate="(form.primarySaleType === 0) ? 'required|decimal:2' : ''"
                        ref="savePlanInput"
                        size="mini"/>
                    </div>
                    <div>
                      <a v-tooltip.top-center="'刪除'" class="btn btn-danger btn-link btn-sm" @click="handlePrimaryDeleteRow(index)" v-show='form.primaryGoods.length > 1'>
                          <i class="fa fa-close" style='color:red' />
                      </a>
                    </div>              
                  </div>  
                </div>
                <div class='text-danger invalid-feedback d-block mx-3' v-show="errors.has('goodsNumber')">{{ errors.first('goodsNumber') }}</div>
                <div class='text-danger invalid-feedback d-block mx-3' v-show="errors.has('goodsPrice')">{{ errors.first('goodsPrice') }}</div>
                <div class="p-3"><l-button type="primary btn-sm" @click="handlePrimaryNewRow()">新增貨號</l-button></div>
              </card>

              <!-- accessories -->
              <card class='col-12' v-show=!form.isAdditional>
                <div slot="header">配件商品</div>

                <fg-input
                  label="商品名稱"
                  placeholder='填寫配件商品名稱後，以下資料才會生效'
                  class='row mx-3'
                  type="text"
                  name="accessoryItemName"
                  data-vv-as="配件商品名稱"
                  labelClasses="ml-1 mr-3 my-auto"
                  inputClasses="col-md-9 col-12"
                  v-model="form.accessoryItemName"
                  :error="getError('accessoryItemName')" />

                <div class="row mx-1">
                  <div class='col-3 align-items-start'>
                    <div class="row" style="height: 40px;">
                      <l-checkbox
                        v-model='form.syncPrimary'
                        class="my-auto ml-3"
                        :change="syncPrimaryChanged()">數量同步主要商品</l-checkbox>
                    </div>
                  </div>
                  

                  <div class='col-md-9 row'>
                    <fg-input
                      label="倍數"
                      class="col-7"
                      :error="getError('syncPrimaryMultiple')">
                      <el-select
                        class="select-default col-md-7 col-12"
                        data-vv-as="倍數"
                        placeholder="請選擇"
                        name="syncPrimaryMultiple"
                        v-model="form.syncPrimaryMultiple"
                        :error="getError('syncPrimaryMultiple')"
                        v-bind:disabled="(!form.syncPrimary && form.accessorySaleType !== 2)"
                        v-validate="(form.syncPrimary || (form.accessorySaleType === 2)) ? 'required' : ''" >
                        <el-option v-for="i in multiple" class="select-default" :value="i.id" :label="i.text" :key="'E'+ i.id" />
                      </el-select>
                    </fg-input>
                  </div>
                </div>

                <div class='col-12 row' v-show=!form.syncPrimary v-bind:disabled=!form.syncPrimary>
                  <fg-input class="col-3" :error="getError('accessorySaleType')">
                    <el-select
                      class="select-default"
                      data-vv-as="配件商品選項"
                      placeholder="請選擇"
                      name="accessorySaleType"
                      v-model="form.accessorySaleType"
                      :error="getError('')"
                      v-validate="(form.accessoryItemName && !form.syncPrimary)? 'required' : ''"
                      clearable=""
                      :change="accessorySaleTypeChanged()"
                      v-bind:disabled=form.syncPrimary>
                      <el-option v-for="i in subSaleTypeOptions" class="select-default" :value="i.id" :label="i.text" :key="'F'+ i.id" />
                    </el-select>
                  </fg-input>

                  <fg-input
                    label="任選入數"
                    class="col-4"
                    :error="getError('accessoryCount')">
                    <el-select
                      class="select-default col-md-7 col-12"
                      data-vv-as="任選入數"
                      placeholder="請選擇"
                      name="accessoryCount"
                      v-model="form.accessoryCount"
                      :error="getError('accessoryCount')"
                      v-bind:disabled="form.accessorySaleType !== 1"
                      v-validate="form.accessorySaleType === 1 ? 'required' : ''" >
                      <el-option v-for="i in itemCount" class="select-default" :value="i.id" :label="i.name" :key="'G'+ i.id" />
                    </el-select>
                  </fg-input>

                  <fg-input
                    label="任選金額"
                    class="col-5 row"
                    type="number"
                    name="accessoryTotalPrice"
                    labelClasses="ml-1 mr-3 my-auto"
                    inputClasses="col-md-6 col-12"
                    data-vv-as="任選金額"
                    v-model="form.accessoryTotalPrice"
                    v-bind:disabled="form.accessorySaleType !== 1"
                    :error="getError('accessoryTotalPrice')"
                    v-validate="form.accessorySaleType === 1 ? 'required|decimal:2' : ''" />
                </div>

                <div class='col-12'>
                  <div class='goodList row' v-bind:key='"H" + index' v-for="(item, index) in form.accessoryGoods">
                    <div class='col-3'>
                      <input
                        type="text"
                        placeholder="貨號"
                        class="form-control d-inline"
                        style="height: 24px; border-radius: 3px;"
                        v-model="item.goodsNumber"
                        ref="savePlanInput" />
                    </div>
                    <div class='ml-2'>
                      <label>金額</label>
                      <input
                        type="number"
                        placeholder="金額"
                        class="form-control input-new-tag"
                        v-model="item.price"
                        v-bind:disabled="(!form.syncPrimary && form.accessorySaleType !== 0)"
                        ref="savePlanInput"
                        size="mini"/>
                    </div>
                    <div>
                      <a v-tooltip.top-center="'刪除'" class="btn btn-danger btn-link btn-sm" @click="handleAccessoryDeleteRow(index)" v-show='form.accessoryGoods.length > 1'>
                          <i class="fa fa-close" style='color:red' />
                      </a>
                    </div>              
                  </div> 
                </div>
                <div class="p-3"><l-button type="primary btn-sm" @click="handleAccessoryNewRow()">新增貨號</l-button></div>
              </card>
              <!-- <div class='text-danger invalid-feedback d-block' v-show="errors.has('userGroupId')">{{ errors.first('userGroupId') }}</div> -->
        
              <div class="text-right">
                <button type="submit" @click.prevent="validate" class="btn btn-fill btn-info align-right">送出</button>
              </div>
            </el-dialog>
          </div>
        </div>
      </div>
    </card>
  </div>
</template>
<script>
 /* eslint-disable */ 
  import { Dialog, Table, TableColumn, Select, Option, Tag } from 'element-ui'
  import { Checkbox } from 'src/components/index'
  import lib from '../../lib'
  import tools from '../../tools'

  export default {
    name: "Plan",
    props: ['saleGroup'],
    components: {
      [Select.name]: Select,
      [Option.name]: Option,
      [Dialog.name]: Dialog,
      [Table.name]: Table,
      [TableColumn.name]: TableColumn,
      [Checkbox.name]: Checkbox,
      [Tag.name]: Tag
    },
    
    data() {
      return {
        form: {
          id: '',

          planName: null,
          isAdditional: false,
          dependPlans: [],
          freeShipping: false,

          primaryItemName: null,
          primarySaleType:'',
          primaryCount: '',
          primaryTotalPrice: '',
          primaryGoods: [{}],
          
          accessoryItemName: null,
          syncPrimary: false,
          syncPrimaryMultiple: '',
          accessorySaleType: '',
          accessoryCount: '',
          accessoryTotalPrice: '',
          accessoryGoods: [{}]
        },

        accessoryCleared: false,

        planData: {
          plan: {
            name: null,
            freeShipping: false,
            extraPlan: false,
            primaryItemName: null,
            primaryItemQuantity: 0,
            primaryItemPrice: 0,
            accessoryName: null,
            accessorySyncQuantity: 0,
            accessoryQuantity: 0,
            accessoryPrice: 0
          },
          planDetails: [],
          dependedPlans: []
        },

        dependPlan: {
          dynamicTags: ['Tag 1', 'Tag 2', 'Tag 3'],
          inputVisible: false,
          valueInput: ''
        },

        primarySaleTypeOptions: [
          {id:0, text: '單選商品'},
          {id:1, text: '任選商品'},
        ],

        subSaleTypeOptions: [
          {id:0, text: '單選商品'},
          {id:1, text: '任選商品'},
          {id:2, text: '隨機贈送商品'},
        ],

        planLists: [],

        multiple: [
          {id: 1, text: '1'},
          {id: 2, text: '2'},
          {id: 3, text: '3'},
          {id: 4, text: '4'},
          {id: 5, text: '5'},
          {id: 6, text: '6'},
          {id: 7, text: '7'},
          {id: 8, text: '8'},
          {id: 9, text: '9'}
        ],

        itemCount: [],

        modals: {
          custom: false,
        },

        tableData: []
      }
    },

    async mounted() {
      // await this.getGroupData()
      if (this.saleGroup) {
        await this.getData()
      }
    },
    watch: {
      tableData: function(){
        this.$emit('input', this.tableData)
      }
    },
    methods: {
      formToData() {
        // console.log('this.form: ', this.form)
        this.clearPlanData()

        this.planData.plan.name = this.form.planName
        this.planData.plan.freeShipping = this.form.freeShipping
        this.planData.plan.extraPlan = this.form.isAdditional
        this.planData.plan.primaryItemName = this.form.primaryItemName
        this.planData.plan.primaryItemQuantity = (this.form.primarySaleType === 0 ? 1 : this.form.primaryCount)
        if (this.form.primarySaleType === 0) {
          delete this.planData.plan.primaryItemPrice
        } else {
          this.planData.plan.primaryItemPrice = parseFloat(this.form.primaryTotalPrice) || 0
        }

        for(var i = 0; i < this.form.primaryGoods.length; i++) {
          var goods = this.form.primaryGoods[i];
          if (!this.isEmpty(goods)) {
            this.planData.planDetails.push({
              isPrimary: true,
              goodsNumber: goods.goodsNumber,
              price: parseFloat(goods.price) || 0
            })
          }
        }

        // accessories
        if (!this.form.accessoryItemName || this.form.accessoryItemName === "") {
          delete this.planData.plan.accessoryName
          delete this.planData.plan.accessorySyncQuantity
          delete this.planData.plan.accessoryQuantity
          delete this.planData.plan.accessoryPrice
        } else {
          this.planData.plan.accessoryName = this.form.accessoryItemName

          if (this.form.syncPrimary) {
            this.planData.plan.accessoryQuantity = -1
          } else {
            if (this.form.accessorySaleType === 0) {
              this.planData.plan.accessoryQuantity = 1
            } else if (this.form.accessorySaleType === 1) {
              this.planData.plan.accessoryQuantity = this.form.accessoryCount
            } else {
              this.planData.plan.accessoryQuantity = 0
            }
          }
          
          this.planData.plan.accessorySyncQuantity = ((this.form.syncPrimary || this.form.accessorySaleType === 2) ? this.form.syncPrimaryMultiple : 0)
          if (this.form.accessorySaleType === 1) {
            this.planData.plan.accessoryPrice = parseFloat(this.form.accessoryTotalPrice) || 0
          } else {
            delete this.planData.plan.accessoryPrice
          }

          if (!this.planData.plan.extraPlan) {
            for(var i = 0; i < this.form.accessoryGoods.length; i++) {
              var goods = this.form.accessoryGoods[i];
              if (!this.isEmpty(goods)) {
                this.planData.planDetails.push({
                  isPrimary: false,
                  goodsNumber: goods.goodsNumber,
                  price: parseFloat(goods.price) || 0
                })
              }
            }
          }
        }

        if (this.planData.plan.extraPlan) {
          for(var i = 0; i < this.form.dependPlans.length; i++) {
            var dependPlan = this.form.dependPlans[i];
            this.planData.dependedPlans.push(dependPlan)
          }
        }

        // console.log('this.planData: ', this.planData)
      },

      getTitle() {
        return (this.form.id == '')?'新增方案':'編輯方案'
      },

      getError(fieldName) {
        return this.errors.first(fieldName)
      },

      validate() {
        var _this = this
        // console.log(JSON.stringify(this.form))
        this.$validator.validateAll().then(isValid => {
          // console.log('isValid: ', isValid)
          if (!isValid) return;
          if (this.form.id === '') {
            _this.create()
          } else{
            _this.update()
          }
        }).catch(() => {
          alert(this.errors.all())
        })
      },

      openModal(name) {
        this.modals[name] = true
      },

      closeModal(name) {
        this.modals[name] = false
      },

      handleRemoveDepend(tag) {
        this.form.dependPlans.splice(this.form.dependPlans.indexOf(tag), 1)
      },

      handleAddDepend() {
        let inputValue = this.dependPlan.inputValue
        if (inputValue) {
          this.form.dependPlans.push(inputValue)
        }
        this.dependPlan.inputVisible = false
        this.dependPlan.inputValue = ''
      },

      handlePrimaryNewRow() {
        this.form.primaryGoods.push({})
      },

      handlePrimaryDeleteRow(row) {
        if (this.form.primaryGoods.length == 1) return
        this.form.primaryGoods.splice(row, 1);
      },

      handleAccessoryNewRow() {
        this.form.accessoryGoods.push({})
      },

      handleAccessoryDeleteRow(row) {
        if (this.form.accessoryGoods.length == 1) return
        this.form.accessoryGoods.splice(row, 1);
      },

      clearPlanData() {
        this.planData.plan.name = null
        this.planData.plan.freeShipping = false
        this.planData.plan.extraPlan = false
        this.planData.plan.primaryItemName = null
        this.planData.plan.primaryItemQuantity = 0
        this.planData.plan.primaryItemPrice = 0
        this.planData.plan.accessoryName = null
        this.planData.plan.accessorySyncQuantity = 0
        this.planData.plan.accessoryQuantity = 0
        this.planData.plan.accessoryPrice = 0

        this.planData.planDetails = []
        this.planData.dependedPlans = []
      },

      clearAccessories() {
        this.form.accessoryItemName = null
        this.form.syncPrimary = false
        this.form.syncPrimaryMultiple = ''
        this.form.accessorySaleType = ''
        this.form.accessoryCount = ''
        this.form.accessoryTotalPrice = ''
        this.form.accessoryGoods = [{}]

        this.accessoryCleared = true
      },

      async clearForm() {
        var _this = this
        return new Promise(function(resolve, reject) {
          _this.form.id = ''
          _this.form.planName = null
          // _this.form.content = ''
          _this.form.isAdditional = false
          _this.form.dependPlans = []
          _this.form.freeShipping = false

          _this.form.primaryItemName = null
          _this.form.primarySaleType = ''
          _this.form.primaryCount = ''
          _this.form.primaryTotalPrice = ''
          _this.form.primaryGoods = [{}]

          // _this.form.accessoryItemName = null
          // _this.form.syncPrimary = false
          // _this.form.syncPrimaryMultiple = ''
          // _this.form.accessorySaleType = ''
          // _this.form.accessoryCount = ''
          // _this.form.accessoryTotalPrice = ''
          // _this.form.accessoryGoods = [{}]

          _this.clearAccessories()

          resolve()
        })
      },

      async handlenew() {
        await this.clearForm();
        this.$emit('handlenew');
        this.$validator.errors.clear()
        this.openModal('custom')
      },

      handleEdit(row) {
        // console.log('row: ', row)
        this.form.id = row.id
        this.form.planName = row.name

        this.form.isAdditional = (row.extraPlan === 1)
        this.form.dependPlans = []
        if (this.form.isAdditional) {
          for(var i = 0; i < row.primaryPlans.length; i++) {
            var primaryPlan = row.primaryPlans[i]
            this.form.dependPlans.push(primaryPlan.id)
          }
        }
        this.form.freeShipping = (row.freeShipping === 1)

        this.form.primaryItemName = row.primaryItemName
        this.form.primarySaleType = (row.primaryItemQuantity === 1 ? 0 : 1)
        this.form.primaryCount = (row.primaryItemQuantity === 0 ? '' : row.primaryItemQuantity)
        // this.form.primaryTotalPrice = (row.primaryItemPrice ? row.primaryItemPrice.toString : '')
        this.form.primaryTotalPrice = row.primaryItemPrice
        this.form.primaryGoods = []


        // accessories
        if (row.accessoryName) {
          this.form.accessoryItemName = row.accessoryName
          
          this.form.syncPrimaryMultiple = (row.accessorySyncQuantity === 0 ? '' : row.accessorySyncQuantity)
          if (row.accessoryQuantity === -1) {
            this.form.accessorySaleType = ''
          } else if (row.accessoryQuantity === 0) {
            this.form.accessorySaleType = 2
          } else if (row.accessoryQuantity === 1) {
            this.form.accessorySaleType = 0
          } else {
            this.form.accessorySaleType = 1
          }

          if (row.accessoryQuantity === -1) {
            this.form.syncPrimary = true
          } else {
            this.form.syncPrimary = false
          }
          
          this.form.accessoryCount = (row.accessoryQuantity === 0 ? '' : row.accessoryQuantity)
          this.form.accessoryTotalPrice = row.accessoryPrice
        }
        
        this.form.accessoryGoods = []

        // plan details / goods
        for(var i = 0; i < row.planDetails.length; i++) {
          var planDetail = row.planDetails[i];

          if (planDetail.isPrimary === 1) {
            // primary goods
            this.form.primaryGoods.push({
              goodsNumber: planDetail.goods.goodsNumber,
              // price: (planDetail.price ? planDetail.price.toString : null)
              price: planDetail.price
            })
          } else {
            // accessory goods
            this.form.accessoryGoods.push({
              goodsNumber: planDetail.goods.goodsNumber,
              // price: (planDetail.price ? planDetail.price.toString : null)
              price: planDetail.price
            })
          }
        }

        // console.log('this.form: ', this.form)
        this.openModal('custom')
      },

      async getData() {
        if (this.itemCount.length == 0) {
          for (var i = 2; i <= 99; i++) { 
            this.itemCount.push({
              "id" : i,
              "text" : i.toString()
            })
          }
        }

        // console.log('this.saleGroup: ', this.saleGroup)
        var data = await lib.getPlanList(this.saleGroup.id)
        // console.log('data: ', data)
        if (data.status == 0) {
          var result = data.result
          this.tableData = []
          this.planLists = []
          this.tableData = result.plans

          for(var i = 0; i < this.tableData.length; i++) {
            var plan = this.tableData[i];
            // console.log('plan: ', plan);
            if (!plan.extraPlan) {
              this.planLists.push(plan)
            }
          }
          // planLists
        }
      },

      async update() {
        this.formToData()
        var data = await lib.updatePlan(this.saleGroup.id, this.form.id, this.planData);
        if (data.status == 0) {
          await this.getData()
          this.closeModal('custom')
          this.$swal('已更新', '', 'success')
        }
      },

      async create() {
        this.formToData()
        var data = await lib.createPlan(this.saleGroup.id, this.planData);
        // console.log('data: ', data)
        if (data.status == 0) {
          this.closeModal('custom')
          await this.getData()
          this.$swal('新增成功', '', 'success')
        } else if (data.status == 107) {
          this.$swal('新增失敗', '貨號有誤', 'error')
        } else {
          this.$swal('新增失敗', '', 'error')
        }
      },

      async handleDelete(id) {
        var result = await tools.confirmDialog(this, "確定要刪除?");
          if (result){
            var data = await lib.deletePlan(this.saleGroup.id, id)
          if (data.status == 0){
            await this.getData()
            this.$swal('已刪除', '', 'success')
          }else {
            this.$swal('刪除失敗', '', 'error')
          }
        }
      },

      isAdditionalChanged() {
        if (this.form.isAdditional) {
          if (!this.accessoryCleared) {
            this.clearAccessories()
          }
        } else {
          this.accessoryCleared = false
          if (this.form.dependPlans.length != 0) {
            this.form.dependPlans = []
          }
        }
      },

      syncPrimaryChanged() {
        if (this.form.syncPrimary) {
          this.form.accessorySaleType = ''
          this.form.accessoryCount = ''
          this.form.accessoryTotalPrice = ''
        } else {
          if (this.form.accessorySaleType !== 2) {
            this.form.syncPrimaryMultiple = ''
          }
        }
      },

      primarySaleTypeChanged() {
        if (this.form.primarySaleType === 0) {
          this.form.primaryCount = ''
          this.form.primaryTotalPrice = ''
        } else if (this.form.primarySaleType === 1) {
          for(var i = 0; i < this.form.primaryGoods.length; i++) {
            var goods = this.form.primaryGoods[i];
            delete goods['price']
          }
        } else {
          this.form.primaryCount = ''
          this.form.primaryTotalPrice = ''

          for(var i = 0; i < this.form.primaryGoods.length; i++) {
            var goods = this.form.primaryGoods[i];
            delete goods['price']
          }
        }
      },

      accessorySaleTypeChanged() {
        if (this.form.isAdditional) {
          return
        }

        if (this.form.accessorySaleType === 0) {
          this.form.syncPrimaryMultiple = ''
          this.form.accessoryCount = ''
          this.form.accessoryTotalPrice = ''
        } else if (this.form.accessorySaleType === 1) {
          this.form.syncPrimaryMultiple = ''

          for(var i = 0; i < this.form.accessoryGoods.length; i++) {
            var goods = this.form.accessoryGoods[i];
            delete goods['price']
          }
        } else if (this.form.accessorySaleType === 2) {
          this.form.accessoryCount = ''
          this.form.accessoryTotalPrice = ''

          for(var i = 0; i < this.form.accessoryGoods.length; i++) {
            var goods = this.form.accessoryGoods[i];
            delete goods['price']
          }
        } else {
          this.form.accessoryCount = ''
          this.form.accessoryTotalPrice = ''

          if (!this.form.syncPrimary) {
            for(var i = 0; i < this.form.accessoryGoods.length; i++) {
              var goods = this.form.accessoryGoods[i];
              delete goods['price']
            }
          }
        }
      },

      isEmpty(obj) {
        for(var key in obj) {
            if(obj.hasOwnProperty(key))
                return false;
        }
        return true;
      }
    }
  }
</script>

<style>
.hidden_header {
  display: none;
 
}
.contents {
  display: contents;
  margin-right: 5px;
}

/* .goodList {
  margin: 5px;
} */

.goodList div {
  margin: 2px;
  padding-right: 10px;
}

/* tr:nth-child(1) {  
  text-align: left;
  font-style: normal #AAA;
} */

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance:textfield;
}

</style>
